import { createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import api from '../auth/api'
import { alertSuccess, alertError } from "../components/Alert";


export const fetchGenderList = createAsyncThunk(
    'genderList/fetchGenderList',
    async (_,{rejectWithValue})=>{
        try{
            const response = await api.get('/panel/variable/Gender/India');
            return response.data?.result

        }catch(error){
            return rejectWithValue(error?.response?.data || error.message);
        }
    }
)


const genderSlice = createSlice({
    name:'genderList',
    initialState: {
        genderList: [],
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null, // Stores error messages
      },
      reducers: {
      },
      extraReducers:(builder)=>{
        builder
                .addCase(fetchGenderList.pending, (state) => {
                  state.status = 'loading';
                })
                .addCase(fetchGenderList.fulfilled, (state, action) => {
                  state.status = 'succeeded';
                  state.genderList = action.payload;
                })
                .addCase(fetchGenderList.rejected, (state, action) => {
                  state.status = 'failed';
                  state.error = action.payload;
                })
      }
})

export default genderSlice.reducer;